import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=c21a0362&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Review.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Review.vue?vue&type=style&index=0&id=c21a0362&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21a0362",
  null
  
)

export default component.exports